import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Flame, BatteryLow, Cookie } from 'lucide-react';
export function ProblemSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="py-24 bg-white px-4" data-id="element-196">
      <div className="max-w-6xl mx-auto" data-id="element-197">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-198">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-forest mb-6" data-id="element-199">
            ¿Te Suena Familiar?
          </h2>
          <p className="text-lg text-warmBrown max-w-3xl mx-auto leading-relaxed" data-id="element-200">
            Sabemos lo frustrante que es. No eres la única. Muchas mujeres de 40
            en adelante se sienten igual. Probablemente has probado dietas bajas
            en calorías, suplementos milagrosos, y programas de ejercicios que
            solo te dejaron agotada.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-201">
          {/* Card 1 */}
          <motion.div variants={itemVariants} className="bg-cream p-8 rounded-2xl border border-lightSage hover:shadow-lg transition-shadow duration-300" data-id="element-202">
            <div className="w-14 h-14 bg-sage/10 rounded-full flex items-center justify-center mb-6 text-sage" data-id="element-203">
              <Flame className="w-8 h-8" data-id="element-204" />
            </div>
            <h3 className="text-xl font-heading font-bold text-forest mb-3" data-id="element-205">
              Bochornos Inesperados
            </h3>
            <p className="text-warmBrown/80" data-id="element-206">
              Oleadas de calor que aparecen sin aviso y alteran tu día,
              dejándote incómoda y exhausta.
            </p>
          </motion.div>

          {/* Card 2 */}
          <motion.div variants={itemVariants} className="bg-cream p-8 rounded-2xl border border-lightSage hover:shadow-lg transition-shadow duration-300" data-id="element-207">
            <div className="w-14 h-14 bg-sage/10 rounded-full flex items-center justify-center mb-6 text-sage" data-id="element-208">
              <BatteryLow className="w-8 h-8" data-id="element-209" />
            </div>
            <h3 className="text-xl font-heading font-bold text-forest mb-3" data-id="element-210">
              Fatiga Constante
            </h3>
            <p className="text-warmBrown/80" data-id="element-211">
              Un cansancio que no desaparece sin importar cuánto duermas,
              afectando tu productividad y ánimo.
            </p>
          </motion.div>

          {/* Card 3 */}
          <motion.div variants={itemVariants} className="bg-cream p-8 rounded-2xl border border-lightSage hover:shadow-lg transition-shadow duration-300" data-id="element-212">
            <div className="w-14 h-14 bg-sage/10 rounded-full flex items-center justify-center mb-6 text-sage" data-id="element-213">
              <Cookie className="w-8 h-8" data-id="element-214" />
            </div>
            <h3 className="text-xl font-heading font-bold text-forest mb-3" data-id="element-215">
              Antojos Incontrolables
            </h3>
            <p className="text-warmBrown/80" data-id="element-216">
              Deseos intensos que parecen tomar el control de tu alimentación,
              especialmente por las tardes.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}